module.exports = __webpack_public_path__ + "img/invoice.7259fc34.png";